import { Component, ElementRef, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, firstValueFrom, takeUntil } from 'rxjs';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { SlideCommonService } from '../common/slide-common.service';
import { CommonModule, NgIf } from '@angular/common';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { WINDOW, WINDOW_PROVIDERS } from '@app/shared/services/window/window.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    providers: [
        WINDOW_PROVIDERS
    ],
    imports: [
        CommonModule,
        ConnectSlideComponent,
        ReactiveFormsModule,
        SpinnerComponent,
        NgIf
    ]
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
    @Input() slideNumber: string | undefined;
    @Input() finalSlide = false;
    currentSlide = 'terms';
    active = this.afs.getActive();
    leadModel = this.afs.getLeadModel();
    showSubmit = false;
    showError = false;
    errorMessage = "";
    errors: any = [];
    isDisabled = false;
    submitting = false;

    @Input() termsAndConditionsPageHeading: string = "";
    @Input() termsAndConditionsBodyText: string = "";

    constructor(
        private afs: ApplicationFormService,
        private logger: LoggerService,
        private el: ElementRef,
        private applicationFormDataService: ApplicationFormDataService,
        private slideCommon: SlideCommonService,
        @Inject(WINDOW) private window: Window,
    ) { }

    private destroy$ = new Subject<void>();

    formData = {
        applicationId: null,
        termsAccepted: false
    };

    termsAcceptedControl: FormControl = new FormControl(false, { validators: [ Validators.requiredTrue ] });

    subscription = this.afs.subscribeLeadModel((data: any) => {
        this.formData.applicationId = data.applicationId;
    });

    ctrlSubscription = this.termsAcceptedControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((v) => this.formData.termsAccepted = v)

    get formState() {
        return this.afs.formState;
    }

    ngOnInit() {
        this.afs.getActive();
    }

    onBack() {
        this.submitting = false;
        this.isDisabled = false;
        this.afs.goBack('terms');
        this.slideCommon.scroll(this.active.active);
    }

    onSubmit() {
        this.logger.info('terms submit clicked');

        if (this.termsAcceptedControl.valid) {
            this.isDisabled = true;
            this.submitting = true;

            firstValueFrom(this.applicationFormDataService.postTermsAndConditions(this.formData)).then((response: any) => {
                console.log('additional residents post success ' + response.status);

                this.slideCommon.save(this.termsAcceptedControl, this.currentSlide, this.formState, this.active);

                this.isDisabled = false;
                this.submitting = true;

                this.window.location = '/application/next-steps/';
            }).catch((error) => {
                this.isDisabled = false;
                this.submitting = false;
                this.logger.error(error);
            });
        }
    }

    showModal(event: any) {
        event.preventDefault();
        $('#termsAndConditionsModal').modal({
            show: true
        });
    }

    hideModal() {
        $('#termsAndConditionsModal').modal('hide');
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        this.subscription.unsubscribe();
    }
}
